<script>
//import {Graylog} from '../graylog'

import Funnel from '../components/funnel'


export default {
  components: {
    Funnel
  },

  computed: {
    steps() {
      return ['path:"/api/cars"']
    }
  }

}
</script>

<template>
  <div>

    <funnel :steps="steps">
      <funnel-step search='path:"/api/cars"'></funnel-step>
      <funnel-step search='message:"[GET] Api::CarsController#show"'></funnel-step>

    </funnel>

    yay!

    <hr>
  </div>
</template>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
hr {
  max-width: 100%;
}
</style>
